import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changeset from 'ember-changeset/helpers/changeset';
import add from 'ember-math-helpers/helpers/add';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import ModelList from 'parog-web/components/model-list';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    changeset: EmberChangeset;
  };
}

export default class TreatmentHistoryEditionFormBreastCancerFormOncologySection extends Component<Signature> {
  get #oncologies() {
    return this.args.changeset.get('oncologies');
  }

  onChangesetUpdate = (changeset: EmberChangeset) => {
    changeset.execute();
    this.#setAsDirty();
  };

  #setAsDirty() {
    this.args.changeset.set('oncologies', [].concat(this.#oncologies));
  }

  <template>
    <h2 class='ui dividing header'>Oncologie</h2>

    <div class='field'>

      <div class='field' id='oncologies' data-test-oncology-list>
        <ModelList
          @model={{@changeset}}
          @propertyName='oncologies'
          @addButtonTitle="Ajouter une consultation d'oncologie"
          as |Item|
        >
          {{#let (changeset Item.item) as |oncologyChangeset|}}
            <div class='ui segment' data-test-oncology-list-item={{Item.index}}>
              <h3 class='ui dividing header'>Oncologie {{add Item.index 1}}</h3>
              <i
                class='trash icon absolute right-0 top-0 m-2 opacity-[0.5]'
                role='button'
                {{on 'click' Item.destroy}}
              >
              </i>
              <div>
                <div class='field'>
                  <@form.Date
                    @labelName='Consultation oncologue'
                    @propertyName='consultation'
                    @changeset={{oncologyChangeset}}
                    @onChangesetUpdate={{this.onChangesetUpdate}}
                  />
                </div>
              </div>
            </div>
          {{/let}}
        </ModelList>
      </div>
    </div>
  </template>
}
